class BirthdaySignUp extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.inputs = this.querySelectorAll('.field__input');
    this.submitButton = this.querySelector('button[type="submit"]');
    this.successMessage = this.querySelector('.js-success-message');
    this.errorMessage = this.querySelector('.js-error-message');
    this.appscriptEndpoint = this.getAttribute('data-appscript-endpoint');

    this.addEventListeners()
  }

  addEventListeners() {
    if (!this.form) return;
    this.form.addEventListener('submit', this.handleSubmit.bind(this));
    this.addEventInputs()
  }

  addEventInputs() {
    const inputEls = this.querySelectorAll('.js-input')

    if(!inputEls.length) {
      return
    }

    inputEls.forEach(inputEl => {
      inputEl.addEventListener('input', () => {
        const value = inputEl.value
        if (value) {
          inputEl.classList.add('has-value')
        } else {
          inputEl.classList.remove('has-value')
        }
      })
    })
  }

  async handleSubmit(event) {
    event.preventDefault();
    if (!this.form || !this.submitButton) return;

    // Re-check every required field so the result never depends on listener order.
    this.form.querySelectorAll('.required').forEach((input) => {
      const isEmpty = !String(input.value || '').trim();
      input.classList.toggle('invalid', isEmpty);
      input.classList.toggle('valid', !isEmpty);
    });

    if (!this.validateForm()) {
      const firstInvalid = this.form.querySelector('.invalid');
      if (firstInvalid) {
        firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
        firstInvalid.focus();
      }
      return;
    }

    if (this.errorMessage) this.errorMessage.classList.remove('visible');
    this.submitButton.classList.add('loading');
    this.submitButton.disabled = true;

    const key = (name) => String.fromCharCode(36) + name;
    const formData = new FormData(this.form);
    const data = Object.fromEntries(formData.entries());

    // Parse the date as local time (a bare YYYY-MM-DD is parsed as UTC and shifts back a day in US time zones).
    if (data[key('Birthday')]) {
      data[key('Birthday')] = new Date(data[key('Birthday')] + 'T00:00:00').toLocaleDateString('en-US', { year: 'numeric', month: '2-digit', day: '2-digit' });
    }

    // Klaviyo expects E.164 phone numbers, e.g. +13475551234.
    const phoneDigits = String(data[key('phone_number')] || '').replace(/[^0-9]/g, '');
    const region = data[key('phone_number_region')];
    if (phoneDigits.length === 10 && (!region || region === 'US' || region === 'CA')) {
      data[key('phone_number')] = '+1' + phoneDigits;
    } else if (phoneDigits) {
      data[key('phone_number')] = phoneDigits;
    }

    let klaviyoOk = false;
    try {
      const bodyData = { token: 'XdvmSA', properties: data };
      const res = await fetch('https://a.klaviyo.com/api/identify', {
        method: 'POST',
        headers: { accept: 'text/html', 'content-type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams({ data: JSON.stringify(bodyData) })
      });
      klaviyoOk = (await res.text()).trim() === '1';
    } catch (error) {
      // Often caused by ad/tracking blockers. The Google Sheet below still records the entry.
      console.error('Birthday form: Klaviyo request failed', error);
    }

    let sheetOk = false;
    try {
      await this.submitFormToSheet();
      sheetOk = true;
    } catch (error) {
      console.error('Birthday form: sheet request failed', error);
    }

    if (klaviyoOk || sheetOk) {
      this.handleIdentifyComplete();
    } else if (this.errorMessage) {
      this.errorMessage.classList.add('visible');
    }

    this.submitButton.classList.remove('loading');
    this.submitButton.disabled = false;
  }

  async submitFormToSheet() {
    if (!this.appscriptEndpoint || !this.form) return;

    const formData = new FormData(this.form)

    const dataBody = {
      "firstName": formData.get('$first_name'),
      "lastName": formData.get('$last_name'),
      "phone": formData.get('$phone_number'),
      "addressFirstName": formData.get('$first_name'),
      "addressLastName": formData.get('$last_name'),
      "addressPhone": formData.get('$phone_number'),
      "addressLine1": formData.get('$address'),
      "addressCity": formData.get('$city'),
      "addressProvince": formData.get('$state'),
      "addressCountry": formData.get('$phone_number_region'),
      "addressZip": formData.get('$zip'),
      "email": formData.get('$email'),
      "metafieldFactsBirthDateDate": formData.get('$Birthday'),
      "action":"ADD"
    };

    const response = await fetch(this.appscriptEndpoint, {
      redirect: 'follow',
      method: 'POST',
      body: JSON.stringify(dataBody),
      headers: {
        "Content-Type": "text/plain;charset=utf-8",
      }
    })

    const data = await response.json()

    if (data.error) {
      throw new Error(data.message)
    }
  }

  handleIdentifyComplete() {
    if (!this.successMessage || !this.form) return;

    this.successMessage.classList.add('visible');
    this.form.classList.add('hidden');
  }

  validateForm() {
    const invalidFields = this.form.querySelectorAll('.invalid');
    return invalidFields.length === 0;
  }
}

customElements.define('birthday-sign-up', BirthdaySignUp);

// Custom Select
class CustomSelect extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.options = this.querySelectorAll('.custom-select__option');
    this.input = this.querySelector('input[type="hidden"]');
    this.currentValue = this.querySelector('.custom-select__current-value');
    this.bindEvents();
  }

  bindEvents() {
    if (!this.details || !this.summary || !this.options || !this.input || !this.currentValue) {
      return;
    }

    // Close when clicking outside
    document.addEventListener('click', (event) => {
      const isClickInside = this.contains(event.target);
      if (!isClickInside && this.details.hasAttribute('open')) {
        this.details.removeAttribute('open');
      }
    });

    // Handle option selection
    this.options.forEach(option => {
      option.addEventListener('click', () => {
        this.handleOptionClick(option);
      });
    });
  }

  handleOptionClick(option) {
    const value = option.dataset.value;
    const image = option.querySelector('img').cloneNode(true);

    // Update summary display
    this.currentValue.innerHTML = '';
    this.currentValue.appendChild(image);

    // Update hidden input
    this.input.value = value;

    // Close dropdown
    this.details.removeAttribute('open');
  }
}

customElements.define('custom-select', CustomSelect);
